const baseUrl = import.meta.env.VITE_API_BASE_URL

export const SYMPTOMS_CATEGORY_ENDPOINT = `${baseUrl}/symptoms-category`

export const PATIENT_SYMPTOMS_BATCH_ENDPOINT = `${baseUrl}/patient-symptoms/batch`
export const BASE_PATIENT_PAIN_ENDPOINT = `${baseUrl}/patient-pain`

export const SYMPTOMS_BY_CATEGORY_ENDPOINT = (categoryId: string) =>
  `${SYMPTOMS_CATEGORY_ENDPOINT}/${categoryId}/symptoms`

export const PATIENT_SYMPTOMS_ENDPOINT = (patient_id?: string) =>
  `${baseUrl}/patient-symptoms/patient/${patient_id}`

export const PATIENT_PAINS_ENDPOINT = (patient_id?: string) =>
  `${BASE_PATIENT_PAIN_ENDPOINT}/patient/${patient_id}`
